const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_assignment_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'conversation_view_all_inboxes',
];

const CONTACT_PERMISSIONS_LIST = [
  'contact_manage',
  'contact_view',
  'contact_create',
  'contact_edit',
  'contact_delete',
  'contact_import',
  'contact_export',
  'contact_assignment_manage',
  'contact_hide_other_teams',
  'contact_hide_other_assignees',
  'contact_hide_other_inboxes',
];

const COMPANY_PERMISSIONS_LIST = [
  'company_manage',
  'company_view',
  'company_create',
  'company_edit',
  'company_delete',
  'company_import',
  'company_export',
  'company_assignment_manage',
  'company_hide_other_teams',
  'company_hide_other_assignees',
];

const FRANCHISE_PERMISSIONS_LIST = [
  'franchise_manage',
  'franchise_view',
  'franchise_create',
  'franchise_edit',
  'franchise_delete',
  'franchise_inbox_view_all',
  'franchise_unit_view_all',
  'franchise_view_unassigned_conversations',
  'franchise_contact_view_all',
  'franchise_view_unassigned_contacts',
  'franchise_unit_assign',
];

// `label_private_manage` e `label_private_view` aparecem como checkbox porque a
// privacidade de etiqueta (#1293) e a unica regra de etiqueta que nao se deduz
// das outras: ver a privada de terceiros e privar a propria sao decisoes
// separadas de criar/editar/excluir.
const LABEL_PERMISSIONS_LIST = [
  'label_manage',
  'label_view',
  'label_private_manage',
  'label_private_view',
];

const BOT_PERMISSIONS_LIST = ['bot_manage', 'bot_view', 'bot_knowledge_manage'];

const CANNED_RESPONSE_PERMISSIONS_LIST = [
  'canned_responses_manage',
  'canned_response_view',
  // #1307 — o par de privacidade. Marcar/desmarcar como privada uma resposta que
  // a própria pessoa criou, e ver a resposta privada de outra pessoa. Uma não dá
  // a outra.
  'canned_response_private_manage',
  'canned_response_private_view',
];

const SCHEDULED_MESSAGE_PERMISSIONS_LIST = [
  'scheduled_message_manage',
  'scheduled_message_view',
];

const TASK_PERMISSIONS_LIST = ['task_manage', 'task_view'];

const KANBAN_PERMISSIONS_LIST = ['kanban_manage', 'kanban_view'];

const TEAM_PERMISSIONS_LIST = ['team_manage'];

const CUSTOM_ATTRIBUTE_PERMISSIONS_LIST = [
  'custom_attribute_manage',
  'custom_attribute_view',
];

const INBOX_PERMISSIONS_LIST = ['inbox_manage', 'inbox_agent_bot_manage'];

const CAMPAIGN_PERMISSIONS_LIST = [
  'campaign_manage',
  'campaign_view',
  'campaign_hide_others',
];

// Espelho de PermissionCatalog::SURVEY_PERMISSIONS. Uma família só para CSAT e NPS, com
// os quatro eixos de visibilidade das respostas somando em vez de esconder.
const SURVEY_PERMISSIONS_LIST = [
  'survey_manage',
  'survey_view',
  'survey_create',
  'survey_edit',
  'survey_delete',
  'survey_wallet_manage',
  'survey_response_view',
  'survey_response_view_wallet',
  'survey_response_view_owned',
  'survey_response_view_all',
  'survey_response_comment',
  'survey_response_export',
];

const AUTOMATION_PERMISSIONS_LIST = [
  'automation_manage',
  'automation_view',
  'automation_view_all',
  'automation_create',
  'automation_edit',
  'automation_delete',
  'automation_execute',
  // fora do guarda-chuva do manage de propósito (espelha o backend):
  // publicar automação de evento/agenda é poder de produção
  'automation_publish',
];

const REPORT_PERMISSIONS_LIST = ['report_manage', 'report_view'];

// `custom_report_schedule_manage` e `custom_report_sensitive_data_export` saíram
// daqui na #1582: nada no servidor as lê (agendamento não existe no módulo), e
// checkbox sem efeito é promessa falsa na tela. Continuam válidas no
// PermissionCatalog do backend, então a função que já as tem gravada segue
// salvando — `applyPermissionRules` não as descarta.
const CUSTOM_REPORT_PERMISSIONS_LIST = [
  'custom_report_manage',
  'custom_report_view',
  'custom_report_create',
  'custom_report_edit',
  'custom_report_delete',
  'custom_report_run',
  'custom_report_export',
  'custom_report_share_manage',
  'custom_report_sensitive_data_view',
];

const PORTAL_PERMISSIONS_LIST = ['knowledge_base_manage'];
const RELEASE_NOTE_PERMISSIONS_LIST = ['release_note_view'];
// Espelho de PermissionCatalog::MISC_PERMISSIONS: a seção "Integrações" da tela de funções.
// O par Google entrou na #586. A agenda é do próprio usuário e está no piso de quem não tem
// função personalizada; o Sheets é da conta e, por padrão, só o administrador conecta.
const INTEGRATION_PERMISSIONS_LIST = [
  'channel_whatsapp_connect',
  'google_calendar_connect',
  'google_sheets_connect',
];

// Espelho de PermissionCatalog::FLIP_LEADS_PERMISSIONS. Sem esta lista a permissão existe no
// Ruby mas não aparece na tela de função personalizada; sem o Ruby, o CustomRole é recusado
// no save com "contains unsupported values". Os dois lados andam juntos.
const FLIP_LEADS_PERMISSIONS_LIST = [
  'flip_leads_manage',
  'flip_leads_view',
  'flip_leads_reveal',
  'flip_leads_export',
];

// Espelho de PermissionCatalog::INTERNAL_CHAT_PERMISSIONS (#1748, #1749). `internal_chat_view`
// também está no piso de quem não tem função personalizada (DEFAULT_VIEW_PERMISSIONS, no
// Ruby); `internal_chat_manage` (criar grupo) não está: por padrão, só o administrador da conta
// cria grupo. Depois de criado, quem gerencia é o administrador DO GRUPO (#1764).
const INTERNAL_CHAT_PERMISSIONS_LIST = [
  'internal_chat_view',
  'internal_chat_manage',
];

export const ROLES = ['agent', 'administrator'];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';
export const CONVERSATION_ASSIGNMENT_PERMISSIONS =
  'conversation_assignment_manage';
export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';
export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';
export const CONVERSATION_VIEW_ALL_INBOXES_PERMISSIONS =
  'conversation_view_all_inboxes';

export const CONTACT_VIEW_PERMISSIONS = 'contact_view';
export const CONTACT_PERMISSIONS = CONTACT_VIEW_PERMISSIONS;
export const CONTACT_CREATE_PERMISSIONS = 'contact_create';
export const CONTACT_EDIT_PERMISSIONS = 'contact_edit';
export const CONTACT_DELETE_PERMISSIONS = 'contact_delete';
export const CONTACT_IMPORT_PERMISSIONS = 'contact_import';
export const CONTACT_EXPORT_PERMISSIONS = 'contact_export';
export const CONTACT_ASSIGNMENT_PERMISSIONS = 'contact_assignment_manage';
export const CONTACT_HIDE_OTHER_TEAMS_PERMISSIONS = 'contact_hide_other_teams';
export const CONTACT_HIDE_OTHER_ASSIGNEES_PERMISSIONS =
  'contact_hide_other_assignees';
export const CONTACT_HIDE_OTHER_INBOXES_PERMISSIONS =
  'contact_hide_other_inboxes';

export const COMPANY_VIEW_PERMISSIONS = 'company_view';
export const COMPANY_PERMISSIONS = COMPANY_VIEW_PERMISSIONS;
export const COMPANY_CREATE_PERMISSIONS = 'company_create';
export const COMPANY_EDIT_PERMISSIONS = 'company_edit';
export const COMPANY_DELETE_PERMISSIONS = 'company_delete';
export const COMPANY_IMPORT_PERMISSIONS = 'company_import';
export const COMPANY_EXPORT_PERMISSIONS = 'company_export';
export const COMPANY_ASSIGNMENT_PERMISSIONS = 'company_assignment_manage';
export const COMPANY_HIDE_OTHER_TEAMS_PERMISSIONS = 'company_hide_other_teams';
export const COMPANY_HIDE_OTHER_ASSIGNEES_PERMISSIONS =
  'company_hide_other_assignees';

export const FRANCHISE_VIEW_PERMISSIONS = 'franchise_view';
export const FRANCHISE_PERMISSIONS = FRANCHISE_VIEW_PERMISSIONS;
export const FRANCHISE_CREATE_PERMISSIONS = 'franchise_create';
export const FRANCHISE_EDIT_PERMISSIONS = 'franchise_edit';
export const FRANCHISE_DELETE_PERMISSIONS = 'franchise_delete';
export const FRANCHISE_MANAGE_PERMISSIONS = 'franchise_manage';
export const FRANCHISE_INBOX_VIEW_ALL_PERMISSIONS = 'franchise_inbox_view_all';
export const FRANCHISE_UNIT_VIEW_ALL_PERMISSIONS = 'franchise_unit_view_all';
export const FRANCHISE_VIEW_UNASSIGNED_CONVERSATIONS_PERMISSIONS =
  'franchise_view_unassigned_conversations';

export const LABEL_VIEW_PERMISSIONS = 'label_view';
export const LABEL_CREATE_PERMISSIONS = 'label_create';
export const LABEL_EDIT_PERMISSIONS = 'label_edit';
export const LABEL_DELETE_PERMISSIONS = 'label_delete';
export const LABEL_MANAGE_PERMISSIONS = 'label_manage';
export const LABEL_PRIVATE_MANAGE_PERMISSIONS = 'label_private_manage';
export const LABEL_PRIVATE_VIEW_PERMISSIONS = 'label_private_view';

export const BOT_VIEW_PERMISSIONS = 'bot_view';
export const BOT_CREATE_PERMISSIONS = 'bot_create';
export const BOT_EDIT_PERMISSIONS = 'bot_edit';
export const BOT_DELETE_PERMISSIONS = 'bot_delete';
export const BOT_KNOWLEDGE_MANAGE_PERMISSIONS = 'bot_knowledge_manage';
export const BOT_MANAGE_PERMISSIONS = 'bot_manage';

export const CANNED_RESPONSES_PERMISSIONS = 'canned_response_view';
export const CANNED_RESPONSE_MANAGE_PERMISSIONS = 'canned_responses_manage';
export const CANNED_RESPONSE_CREATE_PERMISSIONS = 'canned_response_create';
export const CANNED_RESPONSE_EDIT_PERMISSIONS = 'canned_response_edit';
export const CANNED_RESPONSE_DELETE_PERMISSIONS = 'canned_response_delete';
export const CANNED_RESPONSE_PRIVATE_MANAGE_PERMISSIONS =
  'canned_response_private_manage';
export const CANNED_RESPONSE_PRIVATE_VIEW_PERMISSIONS =
  'canned_response_private_view';

export const SCHEDULED_MESSAGE_VIEW_PERMISSIONS = 'scheduled_message_view';
export const SCHEDULED_MESSAGE_MANAGE_PERMISSIONS = 'scheduled_message_manage';
export const SCHEDULED_MESSAGE_CREATE_PERMISSIONS = 'scheduled_message_create';
export const SCHEDULED_MESSAGE_EDIT_PERMISSIONS = 'scheduled_message_edit';
export const SCHEDULED_MESSAGE_DELETE_PERMISSIONS = 'scheduled_message_delete';

export const TASK_VIEW_PERMISSIONS = 'task_view';
export const TASK_MANAGE_PERMISSIONS = 'task_manage';
export const TASK_CREATE_PERMISSIONS = 'task_create';
export const TASK_EDIT_PERMISSIONS = 'task_edit';
export const TASK_DELETE_PERMISSIONS = 'task_delete';

export const KANBAN_VIEW_PERMISSIONS = 'kanban_view';
export const KANBAN_CREATE_PERMISSIONS = 'kanban_create';
export const KANBAN_EDIT_PERMISSIONS = 'kanban_edit';
export const KANBAN_DELETE_PERMISSIONS = 'kanban_delete';
export const KANBAN_MANAGE_PERMISSIONS = 'kanban_manage';

export const TEAM_VIEW_PERMISSIONS = 'team_view';
export const TEAM_MANAGE_PERMISSIONS = 'team_manage';
export const TEAM_CREATE_PERMISSIONS = TEAM_MANAGE_PERMISSIONS;
export const TEAM_EDIT_PERMISSIONS = TEAM_MANAGE_PERMISSIONS;
export const TEAM_DELETE_PERMISSIONS = TEAM_MANAGE_PERMISSIONS;

export const CUSTOM_ATTRIBUTE_VIEW_PERMISSIONS = 'custom_attribute_view';
export const CUSTOM_ATTRIBUTE_MANAGE_PERMISSIONS = 'custom_attribute_manage';
export const CUSTOM_ATTRIBUTE_CREATE_PERMISSIONS = 'custom_attribute_create';
export const CUSTOM_ATTRIBUTE_EDIT_PERMISSIONS = 'custom_attribute_edit';
export const CUSTOM_ATTRIBUTE_DELETE_PERMISSIONS = 'custom_attribute_delete';

export const INBOX_VIEW_PERMISSIONS = 'inbox_view';
export const INBOX_CREATE_PERMISSIONS = 'inbox_create';
export const INBOX_EDIT_PERMISSIONS = 'inbox_edit';
export const INBOX_DELETE_PERMISSIONS = 'inbox_delete';
export const INBOX_AGENT_BOT_MANAGE_PERMISSIONS = 'inbox_agent_bot_manage';
export const INBOX_MANAGE_PERMISSIONS = 'inbox_manage';

export const CAMPAIGN_PERMISSIONS = 'campaign_view';
export const CAMPAIGN_CREATE_PERMISSIONS = 'campaign_create';
export const CAMPAIGN_EDIT_PERMISSIONS = 'campaign_edit';
export const CAMPAIGN_DELETE_PERMISSIONS = 'campaign_delete';
export const CAMPAIGN_MANAGE_PERMISSIONS = 'campaign_manage';

export const AUTOMATION_MANAGE_PERMISSIONS = 'automation_manage';
export const AUTOMATION_VIEW_PERMISSIONS = 'automation_view';
export const AUTOMATION_VIEW_ALL_PERMISSIONS = 'automation_view_all';
export const AUTOMATION_CREATE_PERMISSIONS = 'automation_create';
export const AUTOMATION_EDIT_PERMISSIONS = 'automation_edit';
export const AUTOMATION_DELETE_PERMISSIONS = 'automation_delete';
export const AUTOMATION_EXECUTE_PERMISSIONS = 'automation_execute';
export const AUTOMATION_PUBLISH_PERMISSIONS = 'automation_publish';

export const REPORTS_PERMISSIONS = 'report_view';
export const REPORT_MANAGE_PERMISSIONS = 'report_manage';

export const SURVEY_VIEW_PERMISSIONS = 'survey_view';
export const SURVEY_MANAGE_PERMISSIONS = 'survey_manage';
export const SURVEY_CREATE_PERMISSIONS = 'survey_create';
export const SURVEY_EDIT_PERMISSIONS = 'survey_edit';
export const SURVEY_DELETE_PERMISSIONS = 'survey_delete';
export const SURVEY_WALLET_MANAGE_PERMISSIONS = 'survey_wallet_manage';
export const SURVEY_RESPONSE_VIEW_PERMISSIONS = 'survey_response_view';
export const SURVEY_RESPONSE_COMMENT_PERMISSIONS = 'survey_response_comment';
export const SURVEY_RESPONSE_EXPORT_PERMISSIONS = 'survey_response_export';

export const CUSTOM_REPORT_VIEW_PERMISSIONS = 'custom_report_view';
export const CUSTOM_REPORT_MANAGE_PERMISSIONS = 'custom_report_manage';
export const CUSTOM_REPORT_CREATE_PERMISSIONS = 'custom_report_create';
export const CUSTOM_REPORT_EDIT_PERMISSIONS = 'custom_report_edit';
export const CUSTOM_REPORT_DELETE_PERMISSIONS = 'custom_report_delete';
export const CUSTOM_REPORT_RUN_PERMISSIONS = 'custom_report_run';
export const CUSTOM_REPORT_EXPORT_PERMISSIONS = 'custom_report_export';
export const CUSTOM_REPORT_SCHEDULE_MANAGE_PERMISSIONS =
  'custom_report_schedule_manage';
export const CUSTOM_REPORT_SHARE_MANAGE_PERMISSIONS =
  'custom_report_share_manage';
export const CUSTOM_REPORT_SENSITIVE_DATA_VIEW_PERMISSIONS =
  'custom_report_sensitive_data_view';
export const CUSTOM_REPORT_SENSITIVE_DATA_EXPORT_PERMISSIONS =
  'custom_report_sensitive_data_export';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';
export const RELEASE_NOTE_VIEW_PERMISSIONS = 'release_note_view';
export const CHANNEL_WHATSAPP_CONNECT_PERMISSIONS = 'channel_whatsapp_connect';
export const GOOGLE_CALENDAR_CONNECT_PERMISSIONS = 'google_calendar_connect';
export const GOOGLE_SHEETS_CONNECT_PERMISSIONS = 'google_sheets_connect';
export const INTERNAL_CHAT_VIEW_PERMISSIONS = 'internal_chat_view';
export const INTERNAL_CHAT_MANAGE_PERMISSIONS = 'internal_chat_manage';

export const PERMISSION_IMPLICATIONS = {
  conversation_manage: [
    'conversation_unassigned_manage',
    'conversation_participating_manage',
  ],

  contact_manage: [
    'contact_view',
    'contact_create',
    'contact_edit',
    'contact_delete',
    'contact_import',
    'contact_export',
    'contact_assignment_manage',
  ],
  contact_create: ['contact_view'],
  contact_edit: ['contact_view'],
  contact_delete: ['contact_view'],
  contact_import: ['contact_view'],
  contact_export: ['contact_view'],
  contact_assignment_manage: ['contact_view'],

  company_manage: [
    'company_view',
    'company_create',
    'company_edit',
    'company_delete',
    'company_import',
    'company_export',
    'company_assignment_manage',
  ],
  company_create: ['company_view'],
  company_edit: ['company_view'],
  company_delete: ['company_view'],
  company_import: ['company_view'],
  company_export: ['company_view'],
  company_assignment_manage: ['company_view'],

  franchise_manage: [
    'franchise_view',
    'franchise_create',
    'franchise_edit',
    'franchise_delete',
    'franchise_inbox_view_all',
    'franchise_unit_view_all',
    'franchise_view_unassigned_conversations',
    'franchise_contact_view_all',
    'franchise_view_unassigned_contacts',
    'franchise_unit_assign',
  ],
  // Ver o contato de todos os franqueados ja inclui o que ninguem carimbou — espelho de
  // PermissionCatalog::PERMISSION_IMPLICATIONS.
  franchise_contact_view_all: ['franchise_view_unassigned_contacts'],
  franchise_create: ['franchise_view'],
  franchise_edit: ['franchise_view'],
  franchise_delete: ['franchise_view'],

  // Espelho de PermissionCatalog::PERMISSION_IMPLICATIONS. `label_manage` implica
  // os dois tokens de privacidade (#1293): ele e o controle total do dominio, e
  // gerenciar todas as etiquetas sem enxergar algumas delas faria lista e
  // detalhe dizerem coisas diferentes.
  label_manage: [
    'label_view',
    'label_create',
    'label_edit',
    'label_delete',
    'label_private_manage',
    'label_private_view',
  ],
  label_create: ['label_view'],
  label_edit: ['label_view', 'label_delete'],
  label_delete: ['label_view'],
  // `label_private_manage` NAO implica `label_private_view`: privar a PROPRIA
  // etiqueta e um direito sobre o que se criou; ver a privada dos OUTROS e outra
  // coisa.
  label_private_manage: ['label_view'],
  label_private_view: ['label_view'],

  // Espelho de PermissionCatalog::PERMISSION_IMPLICATIONS (automation_manage
  // NÃO implica automation_publish).
  automation_manage: [
    'automation_view',
    'automation_view_all',
    'automation_create',
    'automation_edit',
    'automation_delete',
    'automation_execute',
    'label_view',
    'inbox_view',
    'task_view',
    'bot_view',
    'custom_attribute_view',
  ],
  automation_create: [
    'automation_view',
    'label_view',
    'inbox_view',
    'task_view',
    'bot_view',
    'custom_attribute_view',
  ],
  automation_edit: [
    'automation_view',
    'automation_delete',
    'label_view',
    'inbox_view',
    'task_view',
    'bot_view',
    'custom_attribute_view',
  ],
  automation_delete: ['automation_view'],
  automation_execute: ['automation_view'],
  automation_view_all: ['automation_view'],
  automation_publish: ['automation_view'],

  bot_manage: [
    'bot_view',
    'bot_create',
    'bot_edit',
    'bot_delete',
    'bot_knowledge_manage',
  ],
  bot_create: ['bot_view'],
  bot_edit: ['bot_view', 'bot_delete'],
  bot_delete: ['bot_view'],
  bot_knowledge_manage: ['bot_view'],

  canned_responses_manage: [
    'canned_response_view',
    'canned_response_create',
    'canned_response_edit',
    'canned_response_delete',
    'canned_response_private_manage',
    'canned_response_private_view',
  ],
  canned_response_create: ['canned_response_view'],
  canned_response_edit: ['canned_response_view', 'canned_response_delete'],
  canned_response_delete: ['canned_response_view'],
  canned_response_private_manage: ['canned_response_view'],
  canned_response_private_view: ['canned_response_view'],

  scheduled_message_manage: [
    'scheduled_message_view',
    'scheduled_message_create',
    'scheduled_message_edit',
    'scheduled_message_delete',
    'contact_view',
    'conversation_unassigned_manage',
  ],
  scheduled_message_view: [
    'contact_view',
    'conversation_unassigned_manage',
    'bot_view',
  ],
  scheduled_message_create: [
    'scheduled_message_view',
    'contact_view',
    'conversation_unassigned_manage',
  ],
  scheduled_message_edit: [
    'scheduled_message_view',
    'scheduled_message_delete',
    'contact_view',
    'conversation_unassigned_manage',
  ],
  scheduled_message_delete: ['scheduled_message_view'],

  task_manage: [
    'task_view',
    'task_create',
    'task_edit',
    'task_delete',
    'label_view',
  ],
  task_view: ['label_view'],
  task_create: ['task_view', 'label_view'],
  task_edit: ['task_view', 'task_delete', 'label_view'],
  task_delete: ['task_view', 'label_view'],

  kanban_manage: [
    'kanban_view',
    'kanban_create',
    'kanban_edit',
    'kanban_delete',
  ],
  kanban_create: ['kanban_view'],
  kanban_edit: ['kanban_view', 'kanban_delete'],
  kanban_delete: ['kanban_view'],

  team_manage: ['team_create', 'team_edit', 'team_delete'],
  team_create: ['team_edit'],
  team_edit: ['team_delete'],

  custom_attribute_manage: [
    'custom_attribute_view',
    'custom_attribute_create',
    'custom_attribute_edit',
    'custom_attribute_delete',
  ],
  custom_attribute_create: ['custom_attribute_view'],
  custom_attribute_edit: ['custom_attribute_view', 'custom_attribute_delete'],
  custom_attribute_delete: ['custom_attribute_view'],

  inbox_manage: [
    'inbox_view',
    'inbox_create',
    'inbox_edit',
    'inbox_delete',
    'inbox_agent_bot_manage',
  ],
  inbox_create: ['inbox_view'],
  inbox_edit: ['inbox_view', 'inbox_delete'],
  inbox_delete: ['inbox_view'],
  inbox_agent_bot_manage: ['inbox_view'],

  campaign_manage: [
    'campaign_view',
    'campaign_create',
    'campaign_edit',
    'campaign_delete',
    'contact_view',
    'conversation_unassigned_manage',
    'label_view',
    'inbox_view',
  ],
  campaign_view: [
    'contact_view',
    'conversation_unassigned_manage',
    'label_view',
    'inbox_view',
    'bot_view',
  ],
  campaign_create: [
    'campaign_view',
    'contact_view',
    'conversation_unassigned_manage',
    'label_view',
    'inbox_view',
  ],
  campaign_edit: [
    'campaign_view',
    'campaign_delete',
    'contact_view',
    'conversation_unassigned_manage',
    'label_view',
    'inbox_view',
  ],
  campaign_delete: ['campaign_view'],

  survey_manage: [
    'survey_view',
    'survey_create',
    'survey_edit',
    'survey_delete',
    'survey_wallet_manage',
    'survey_response_view',
    'survey_response_view_wallet',
    'survey_response_view_owned',
    'survey_response_view_all',
    'survey_response_comment',
    'survey_response_export',
    'contact_view',
    'inbox_view',
    'bot_view',
  ],
  flip_leads_manage: [
    'flip_leads_view',
    'flip_leads_reveal',
    'flip_leads_export',
    'contact_view',
  ],
  flip_leads_reveal: ['flip_leads_view', 'contact_view'],
  flip_leads_export: ['flip_leads_view'],
  survey_create: ['survey_view', 'contact_view', 'inbox_view', 'bot_view'],
  survey_edit: [
    'survey_view',
    'survey_delete',
    'contact_view',
    'inbox_view',
    'bot_view',
  ],
  survey_delete: ['survey_view'],
  survey_wallet_manage: ['survey_view', 'contact_view'],
  survey_response_view_wallet: ['survey_response_view'],
  survey_response_view_owned: ['survey_response_view'],
  survey_response_view_all: [
    'survey_response_view',
    'survey_response_view_wallet',
    'survey_response_view_owned',
  ],
  survey_response_comment: ['survey_response_view'],
  survey_response_export: ['survey_response_view'],

  report_manage: ['report_view'],

  custom_report_manage: [
    'custom_report_view',
    'custom_report_create',
    'custom_report_edit',
    'custom_report_delete',
    'custom_report_run',
    'custom_report_export',
    'custom_report_schedule_manage',
    'custom_report_share_manage',
    'custom_report_sensitive_data_view',
    'custom_report_sensitive_data_export',
  ],
  // Espelho de PermissionCatalog::PERMISSION_IMPLICATIONS (#1597): quem cria ajusta o que criou.
  custom_report_create: ['custom_report_view', 'custom_report_edit'],
  custom_report_edit: ['custom_report_view'],
  custom_report_delete: ['custom_report_view'],
  custom_report_run: ['custom_report_view'],
  custom_report_export: ['custom_report_view'],
  // Sem entrada para custom_report_schedule_manage nem para
  // custom_report_sensitive_data_export, como no backend: sem checkbox, elas
  // concederiam executar, exportar e ver dado sensível sem origem visível.
  custom_report_share_manage: ['custom_report_view'],

  // Espelho de PermissionCatalog::PERMISSION_IMPLICATIONS (#1749): quem gerencia grupo abre o chat.
  internal_chat_manage: ['internal_chat_view'],
};

export const expandPermissions = (permissions = []) => {
  const expandedPermissions = new Set(permissions);
  // Ponto fixo pelo TAMANHO do conjunto, e nao por um `let hasChanges` que o
  // callback de dentro do laco escrevia — o `no-loop-func` reclamava disso, e o
  // hook de pre-commit barra qualquer commit que toque neste arquivo. Mesmo
  // resultado: o fecho transitivo para quando nada novo entra.
  let previousSize = -1;

  while (previousSize !== expandedPermissions.size) {
    previousSize = expandedPermissions.size;
    [...expandedPermissions].forEach(permission => {
      const impliedPermissions = PERMISSION_IMPLICATIONS[permission] || [];
      impliedPermissions.forEach(impliedPermission => {
        expandedPermissions.add(impliedPermission);
      });
    });
  }

  return [...expandedPermissions];
};

export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  ...CONVERSATION_PERMISSIONS,
  ...CONTACT_PERMISSIONS_LIST,
  ...COMPANY_PERMISSIONS_LIST,
  ...FRANCHISE_PERMISSIONS_LIST,
  ...LABEL_PERMISSIONS_LIST,
  ...BOT_PERMISSIONS_LIST,
  ...CANNED_RESPONSE_PERMISSIONS_LIST,
  ...SCHEDULED_MESSAGE_PERMISSIONS_LIST,
  ...TASK_PERMISSIONS_LIST,
  ...KANBAN_PERMISSIONS_LIST,
  ...TEAM_PERMISSIONS_LIST,
  ...CUSTOM_ATTRIBUTE_PERMISSIONS_LIST,
  ...INBOX_PERMISSIONS_LIST,
  ...CAMPAIGN_PERMISSIONS_LIST,
  ...SURVEY_PERMISSIONS_LIST,
  ...AUTOMATION_PERMISSIONS_LIST,
  ...REPORT_PERMISSIONS_LIST,
  ...CUSTOM_REPORT_PERMISSIONS_LIST,
  ...PORTAL_PERMISSIONS_LIST,
  ...RELEASE_NOTE_PERMISSIONS_LIST,
  ...FLIP_LEADS_PERMISSIONS_LIST,
  ...INTERNAL_CHAT_PERMISSIONS_LIST,
  ...INTEGRATION_PERMISSIONS_LIST,
];

export const CUSTOM_ROLE_PERMISSION_SECTIONS = [
  {
    key: 'conversations',
    permissions: CONVERSATION_PERMISSIONS,
  },
  {
    key: 'contacts',
    permissions: CONTACT_PERMISSIONS_LIST,
  },
  {
    key: 'companies',
    permissions: COMPANY_PERMISSIONS_LIST,
  },
  {
    key: 'franchises',
    permissions: FRANCHISE_PERMISSIONS_LIST,
    // Sufixo de CUSTOM_ROLE.FORM.PERMISSIONS: nota exibida abaixo dos checkboxes da seção.
    note: 'FRANCHISE_RESPONSIBLE_NOTE',
  },
  {
    key: 'labels',
    permissions: LABEL_PERMISSIONS_LIST,
  },
  {
    key: 'automations',
    permissions: AUTOMATION_PERMISSIONS_LIST,
  },
  {
    key: 'bots',
    permissions: BOT_PERMISSIONS_LIST,
  },
  {
    key: 'canned_responses',
    permissions: CANNED_RESPONSE_PERMISSIONS_LIST,
  },
  {
    key: 'scheduled_messages',
    permissions: SCHEDULED_MESSAGE_PERMISSIONS_LIST,
  },
  {
    key: 'tasks',
    permissions: TASK_PERMISSIONS_LIST,
  },
  {
    key: 'kanban',
    permissions: KANBAN_PERMISSIONS_LIST,
  },
  {
    key: 'teams',
    permissions: TEAM_PERMISSIONS_LIST,
  },
  {
    key: 'custom_attributes',
    permissions: CUSTOM_ATTRIBUTE_PERMISSIONS_LIST,
  },
  {
    key: 'inboxes',
    permissions: INBOX_PERMISSIONS_LIST,
  },
  {
    key: 'campaigns',
    permissions: CAMPAIGN_PERMISSIONS_LIST,
  },
  {
    key: 'surveys',
    permissions: SURVEY_PERMISSIONS_LIST,
  },
  {
    key: 'reports',
    permissions: REPORT_PERMISSIONS_LIST,
  },
  {
    key: 'custom_reports',
    permissions: CUSTOM_REPORT_PERMISSIONS_LIST,
  },
  {
    key: 'knowledge_base',
    permissions: PORTAL_PERMISSIONS_LIST,
  },
  {
    key: 'release_notes',
    permissions: RELEASE_NOTE_PERMISSIONS_LIST,
  },
  {
    key: 'flip_leads',
    permissions: FLIP_LEADS_PERMISSIONS_LIST,
  },
  {
    key: 'internal_chat',
    permissions: INTERNAL_CHAT_PERMISSIONS_LIST,
  },
  {
    key: 'integrations',
    permissions: INTEGRATION_PERMISSIONS_LIST,
  },
];

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [...ROLES, MANAGE_ALL_CONVERSATION_PERMISSIONS],
  },
  groups: {
    count: 'groupCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
};

export { CONVERSATION_PERMISSIONS };
